import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      data-name="Asset 1"
      xmlns="http://www.w3.org/2000/svg"
      width={450}
      height={353.33}
      viewBox="0 0 474.128 353.33"
      {...props}
    >
      <g data-name="Layer 2">
        <g data-name="Background complete">
          <path
            data-name="Rectangle 1776"
            fill="#e6e6e6"
            d="M0 310.507h474.128v.237H0z"
          />
          <path
            data-name="Rectangle 1777"
            fill="#e6e6e6"
            d="M86.955 324.854h31.406v.237H86.955z"
          />
          <path
            data-name="Rectangle 1778"
            fill="#e6e6e6"
            d="M58.82 324.854h18.197v.237H58.82z"
          />
          <path
            data-name="Rectangle 1779"
            fill="#e6e6e6"
            d="M181.458 328.343h18.197v.237h-18.197z"
          />
          <path
            data-name="Rectangle 1780"
            fill="#e6e6e6"
            d="M253.583 333.635h40.955v.237h-40.955z"
          />
          <path
            data-name="Rectangle 1781"
            fill="#e6e6e6"
            d="M239.141 333.635h6.002v.237h-6.002z"
          />
          <path
            data-name="Rectangle 1782"
            fill="#e6e6e6"
            d="M341.059 328.343h88.833v.237h-88.833z"
          />
          <path
            data-name="Path 11427"
            d="M224.737 268.214H41.638a5.415 5.415 0 01-5.405-5.414V5.415A5.415 5.415 0 0141.638 0h183.1a5.415 5.415 0 015.415 5.415V262.8a5.415 5.415 0 01-5.416 5.414zM41.638.237a5.177 5.177 0 00-5.168 5.177V262.8a5.177 5.177 0 005.168 5.177h183.1a5.187 5.187 0 005.177-5.177V5.415a5.187 5.187 0 00-5.178-5.178z"
            fill="#e6e6e6"
          />
          <path
            data-name="Path 11428"
            d="M429.854 268.214H246.746a5.424 5.424 0 01-5.415-5.414V5.415A5.424 5.424 0 01246.746 0h183.108a5.415 5.415 0 015.4 5.415V262.8a5.415 5.415 0 01-5.4 5.414zM246.746.237a5.187 5.187 0 00-5.177 5.177V262.8a5.187 5.187 0 005.177 5.177h183.108a5.187 5.187 0 005.177-5.177V5.415a5.187 5.187 0 00-5.177-5.178z"
            fill="#e6e6e6"
          />
          <path
            data-name="Path 11802"
            d="M232.712 229.497h20.852v82.716h-20.852z"
            fill="#472a04"
          />
          <path
            data-name="Path 11429"
            d="M249.6 312.223h3.964v-11.265h-8.117z"
            fill="#472a04"
          />
          <path
            data-name="Rectangle 1784"
            fill="#e0e0e0"
            d="M141.338 229.497h20.852v82.716h-20.852z"
          />
          <path
            data-name="Rectangle 1785"
            fill="#d77f0b"
            d="M158.738 229.497h94.826v75.804h-94.826z"
          />
          <path
            data-name="Path 11430"
            d="M250.121 233.271v20.065h-87.97v-20.065h87.941m.37-.36H161.81v20.782h88.681v-20.83z"
            fill="#e0e0e0"
          />
          <path
            data-name="Path 11431"
            d="M162.692 312.223h-3.954v-11.265h8.108z"
            fill="#fafafa"
          />
          <path
            data-name="Path 11432"
            d="M204.055 243.257a2.1 2.1 0 102.1-2.1 2.1 2.1 0 00-2.1 2.1z"
            fill="#e6e6e6"
          />
          <path
            data-name="Path 11433"
            d="M250.121 257.377v20.056h-87.97v-20.056h87.941m.37-.36H161.81v20.824h88.681v-20.864z"
            fill="#e0e0e0"
          />
          <path
            data-name="Path 11434"
            d="M204.055 267.409a2.1 2.1 0 102.1-2.1 2.1 2.1 0 00-2.1 2.1z"
            fill="#e6e6e6"
          />
          <path
            data-name="Path 11435"
            d="M250.121 281.528v20.018h-87.97v-20.018h87.941m.37-.37H161.81v20.8h88.681v-20.8z"
            fill="#e0e0e0"
          />
          <path
            data-name="Path 11436"
            d="M204.055 291.551a2.1 2.1 0 102.1-2.1 2.1 2.1 0 00-2.1 2.1z"
            fill="#e6e6e6"
          />
          <path
            data-name="Rectangle 1786"
            fill="#e0e0e0"
            d="M128.603 181.458h20.852v130.765h-20.852z"
          />
          <path
            data-name="Path 11437"
            d="M145.487 312.223h3.964v-11.265h-8.104z"
            fill="#fafafa"
          />
          <path
            data-name="Rectangle 1787"
            fill="#472a04"
            d="M50.675 181.458h20.852v130.765H50.675z"
          />
          <path
            data-name="Rectangle 1788"
            fill="#d77f0b"
            d="M68.066 181.458h81.389V305.31H68.066z"
          />
          <path
            data-name="Path 11438"
            d="M145.946 184.967v28.04H71.574v-28.04h74.372m.436-.427H71.119v28.9h75.244v-28.9z"
            fill="#e0e0e0"
          />
          <path
            data-name="Path 11439"
            d="M145.947 216.42v74.372H110.52V216.42h35.427m.436-.436h-36.29v75.244h36.29v-75.244z"
            fill="#e0e0e0"
          />
          <path
            data-name="Path 11440"
            d="M107.001 216.42v74.372H71.574V216.42h35.427m.427-.436H71.119v75.244h36.29v-75.244z"
            fill="#e0e0e0"
          />
          <path
            data-name="Path 11441"
            d="M72.03 312.223h-3.964v-11.265h8.12z"
            fill="#472a04"
          />
          <path
            data-name="Path 11442"
            d="M106.66 198.992a2.105 2.105 0 102.105-2.1 2.105 2.105 0 00-2.105 2.1z"
            fill="#e6e6e6"
          />
          <path
            data-name="Path 11443"
            d="M114.17 251.829a2.105 2.105 0 102.1-2.1 2.105 2.105 0 00-2.1 2.1z"
            fill="#e6e6e6"
          />
          <path
            data-name="Path 11444"
            d="M99.159 251.829a2.1 2.1 0 102.1-2.1 2.1 2.1 0 00-2.1 2.1z"
            fill="#e6e6e6"
          />
          <path
            data-name="Path 11445"
            d="M96.788 145.007h-8.79a92.873 92.873 0 011.527 12.915c0 4.741-6.695 23.536 2.845 23.536s2.845-18.757 2.845-23.536a92.871 92.871 0 011.574-12.915z"
            fill="#e0e0e0"
          />
          <path
            data-name="Path 11446"
            d="M63.344 164.238v5.69a11.55 11.55 0 0011.512 11.51h5.688a11.54 11.54 0 0011.513-11.51v-5.69z"
            fill="#f5f5f5"
          />
          <path
            data-name="Path 11447"
            d="M185.545 217.445c0 6.638 7.425 12.052 16.5 12.052h8.193c9.075 0 16.5-5.424 16.5-12.052z"
            fill="#e0e0e0"
          />
          <path
            data-name="Path 11448"
            d="M402.639 207.744c-4.969 4.049-11.834 11.483-18.112 21.924a56.443 56.443 0 00-7.823 23.887c0-10.9.066-22.616.1-33.673 1.261-2.845 4.144-9.407 6.211-14.584 6.894-17.3 9.483-21.544 15.675-36.451 8.278-19.913 16.756-43.487 14.328-41.609-4.95 3.85-23.915 39.362-25.963 44.445a142.237 142.237 0 00-10.232 42.529c0-10.431.076-19.913.114-27.281.133-23.991.541-31.738.74-34.137.768-1.214 1.669-2.627 2.2-3.395 4.457-6.439 6.173-11.929 10.364-21.535 5.955-13.617 11.076-37.788 9.577-36.565-6.24 5.073-11.151 15.988-17.619 29.9s-4.618 21.9-5.9 33.777c-.266 2.333-.474 11.123-.626 23.318-1.669-12.991-4.817-21.544-10.554-29.32-7.055-9.568-13.883-16.035-18.889-19.4s8.648 20.122 15.172 30.344c5.813 9.132 11.17 17.192 14.224 25.129-.161 16.519-.237 37.437-.237 56.9-1.5-8.866-3.945-18.406-7.207-25.793-3.926-8.876-9.957-22.493-14.764-27.12-1.147-1.109 5.026 25.375 8.989 32.421s6.875 13.683 9.369 17.675c.578.948 2.513 4.523 3.613 6.638 0 23.773.133 44.748.341 51.889h1.036c-.066-1.849-.085-13.939-.057-29.946 2.475-8.686 8.127-18.6 12.792-27.651 5.078-9.88 18.107-36.374 13.138-32.316z"
            fill="#b8d98a"
          />
          <path
            data-name="Path 11449"
            d="M391.103 312.222H361.38l-2.247-29.13h34.213z"
            fill="#472a04"
          />
          <path
            data-name="Path 11450"
            d="M395.555 286.487h-38.641l-1.1-9.833h40.851z"
            fill="#472a04"
          />
          <path
            data-name="Rectangle 1789"
            fill="#e0e0e0"
            d="M64.681 19.477h53.15v58.365h-53.15z"
          />
          <path
            data-name="Rectangle 1790"
            fill="#f5f5f5"
            d="M68.682 19.477h54.904v58.365H68.682z"
          />
          <path
            data-name="Rectangle 1791"
            fill="#fff"
            d="M118.987 24.086v49.167H73.281V24.086z"
          />
          <path
            data-name="Rectangle 1792"
            fill="#f5f5f5"
            d="M107.912 35.996v25.328H84.367V35.996z"
          />
          <path
            data-name="Rectangle 1793"
            fill="#e0e0e0"
            d="M339.457 26.286h49.376v54.221h-49.376z"
          />
          <path
            data-name="Rectangle 1794"
            fill="#f5f5f5"
            d="M343.184 26.286h50.997v54.221h-50.997z"
          />
          <path
            data-name="Rectangle 1795"
            fill="#fff"
            d="M389.914 30.562V76.23h-42.453V30.562z"
          />
          <circle
            data-name="Ellipse 593"
            cx={13.247}
            cy={13.247}
            r={13.247}
            transform="translate(355.435 40.149)"
            fill="#f5f5f5"
          />
          <path
            data-name="Rectangle 1796"
            fill="#e0e0e0"
            d="M133.619 54.278h39.429v43.297h-39.429z"
          />
          <path
            data-name="Rectangle 1797"
            fill="#f5f5f5"
            d="M136.587 54.278h40.728v43.297h-40.728z"
          />
          <path
            data-name="Rectangle 1798"
            fill="#fff"
            d="M173.901 57.692v36.47h-33.9v-36.47z"
          />
          <path
            data-name="Path 11451"
            d="M156.955 66.71l-9.274 16.063h18.548z"
            fill="#f5f5f5"
          />
        </g>
        <ellipse
          data-name="Ellipse 594"
          cx={183.857}
          cy={10.734}
          rx={183.857}
          ry={10.734}
          fill="#f5f5f5"
          transform="translate(53.207 331.861)"
        />
        <g data-name="Character 2">
          <path
            data-name="Path 11452"
            d="M331.179 102.867l-9.407-3.793s-12.413 22.635-15.969 23.773c-4.836 1.555-14.85 5.879-20.786 6.695-.806.948-2.124 3.888-2 4.969 7.975 2.655 25.5-.872 29.254-3.66 8.543-6.373 18.908-27.984 18.908-27.984z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11453"
            d="M334.073 97.728c1.754 6.486-7.747 19.515-7.747 19.515l-12.451-7s2.333-5.358 5.177-10.81c4.56-8.808 13.021-9.102 15.021-1.705z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 11455"
            d="M318.813 113.032l4.9 2.74.863-15.039c-2.852 2.19-4.862 8.79-5.763 12.299z"
            opacity={0.2}
          />
          <path
            data-name="Path 11456"
            d="M325.878 92.844s-9.691 21.563-4.04 61.722h38.187c.607-5.86-1.4-34.46 5.87-62.082a98.031 98.031 0 00-12.688-1.612 140.229 140.229 0 00-16.225 0 74.846 74.846 0 00-11.1 1.972z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 11458"
            d="M317.021 343.449c-.057 1.015 14.423 1.84 32.336 1.84s32.5-.825 32.554-1.84-14.413-1.849-32.336-1.849-32.488.834-32.554 1.849z"
            fill="#e8ecf1"
          />
          <path
            data-name="Rectangle 1799"
            fill="#e58a7b"
            d="M335.717 319.329l6.773-2.622 5.834 15.071-6.773 2.622z"
          />
          <path
            data-name="Path 11459"
            d="M372.713 336.159h-7.14l-2.618-16.53h7.14z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11460"
            d="M365.079 335.332h8.022a.578.578 0 01.578.484l1.034 6.353a1.119 1.119 0 01-1.119 1.271c-2.8-.057-4.144-.218-7.671-.218-2.172 0-6.638.228-9.653.228s-3.215-2.968-1.972-3.234c5.576-1.2 7.738-2.845 9.6-4.447a1.83 1.83 0 011.185-.436z"
            fill="#263238"
          />
          <path
            data-name="Path 11461"
            d="M341.372 332.838l7.586-2.209a.6.6 0 01.711.294l2.845 5.69a1.09 1.09 0 01-.711 1.508c-2.759.749-4.608 1.223-8.06 2.228-2.38.692-4.808 1.821-7.159 2.57-1.631.522-5.462.541-7.444.541-2.93 0-3.584-3.091-2.323-3.234 3.177-.36 3.6-.19 5.358-1.072a24.524 24.524 0 007.662-5.291 3.659 3.659 0 011.536-1.024z"
            fill="#263238"
          />
          <path
            data-name="Path 11462"
            d="M286.212 129.456l-7.851-3.338-3.234 8.7a32.241 32.241 0 009.71 0z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11463"
            d="M272.52 125.938l-.209 5.784 2.816 3.129 3.234-8.705z"
            fill="#e58a7b"
          />
          <path
            data-name="Rectangle 1800"
            fill="#cf6f64"
            d="M336.645 320.45l6.794-2.623 3.009 7.793-6.794 2.623z"
          />
          <path
            data-name="Path 11464"
            d="M370.095 319.629h-7.14l1.356 8.525h7.14z"
            fill="#cf6f64"
          />
          <path
            data-name="Path 11465"
            d="M320.625 143.69c.142 1.716.3 3.471.512 5.272l28.391-9.217a20.264 20.264 0 0010.924-7.937c.114-2.532.256-5.2.474-7.975.095-1.356.209-2.74.332-4.144s.294-2.949.474-4.447z"
            opacity={0.2}
          />
          <path
            data-name="Path 11466"
            d="M329.898 112.596l-.948-.123c.559-4.741 4.1-8.468 7.823-8.383v.948c-3.262-.066-6.372 3.31-6.875 7.558z"
            fill="#fff"
          />
          <path
            data-name="Path 11467"
            d="M334.953 121.377h-.161v-.948c3.262.123 6.325-3.281 6.827-7.52l.948.114c-.502 4.608-3.925 8.354-7.614 8.354z"
            fill="#fff"
          />
          <path
            data-name="Path 11468"
            d="M352.675 72.58c-1.337 5.225-2.911 14.793.531 18.282 0 0-2.409 5.3-12.109 5.3-8.866 0-4.115-5.3-4.115-5.3 5.9-1.394 6-5.69 5.225-9.767z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11469"
            d="M348.408 76.06l-6.192 5.026a16.8 16.8 0 01.332 2.845c1.811 1.8 5.443-2.759 5.813-5.092a7.585 7.585 0 00.047-2.779z"
            fill="#cf6f64"
          />
          <path
            data-name="Path 11470"
            d="M331.567 72.523a6.221 6.221 0 004.03 2.968c2.276.512 3.414-1.584 2.788-3.689-.559-1.9-2.428-4.447-4.741-4.011a3.167 3.167 0 00-2.077 4.732z"
            fill="#cf6f64"
          />
          <path
            data-name="Path 11471"
            d="M335.332 55.804c-3.546 1.622-4.8 15.713-.341 17.8s7.055-20.881.341-17.8z"
            fill="#263238"
          />
          <path
            data-name="Path 11472"
            d="M353.756 64.728c-.853 7.065-.948 11.227-4.741 14.859a9.122 9.122 0 01-15.513-4.836c-1.147-6.353.436-16.851 7.529-19.667a9.132 9.132 0 0112.726 9.644z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11473"
            d="M342.102 59.465c5.253-1.337 9.113-2.257 7.728 2.124-1.83 5.832-4.03 11.483-1.081 11.749 1.8.161 9.767-3.215 8.752-6.638-.882-2.978 2.845-3.793 3.509-5.3 2.456-5.462-4.571-4.741-3.319-8.06s-5.69-8.667-9.483-6.012c-6.173 4.305-16.765 4.248-11.2-2.845 3.992-5.054-3.129-4.021-3.129-4.021s4.305 2.551-2.94 6.5c-7.66 4.244-.633 15.528 11.163 12.503z"
            fill="#263238"
          />
          <path
            data-name="Path 11474"
            d="M356.545 72.523a7.292 7.292 0 01-4.371 2.968c-2.344.513-3.244-1.587-2.362-3.687.787-1.9 2.949-4.447 5.187-4.011s2.75 2.872 1.546 4.73z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11475"
            d="M321.838 154.566s-6.41 57.36-6.913 79.132c-.512 22.654 21.725 93.308 21.725 93.308l11.379-4.741s-13.276-64.548-11.379-86.784c1.982-24.3 10.289-80.915 10.289-80.915z"
            fill="#18206b"
          />
          <path
            data-name="Path 11476"
            d="M337.77 170.307c-5.111 10.6-1.669 31.558 1.1 43.99 1.053-8.771 2.3-18.292 3.49-27.1-.115-13.553-1.167-24.002-4.59-16.89z"
            opacity={0.2}
          />
          <path
            data-name="Path 11477"
            d="M347.527 318.491c.057 0 1.346 3.632 1.346 3.632l-13.124 5.509-2.067-3.84z"
            fill="#407bff"
          />
          <path
            data-name="Path 11478"
            d="M335.389 154.566s4.9 54.563 8.146 75c3.565 22.388 17.543 96.95 17.543 96.95h13.076s-7.833-72.76-9.312-94.92c-1.612-24.051-4.817-77.03-4.817-77.03z"
            fill="#18206b"
          />
          <path
            data-name="Path 11479"
            d="M374.353 323.09c.057 0 .436 3.66.436 3.66h-14.376l-1.024-4.201z"
            fill="#407bff"
          />
          <path
            data-name="Path 11480"
            d="M369.346 318.776a.123.123 0 01-.123-.1c-.076-.664-7.14-66.378-8.468-86.291-1.441-21.611-4.343-69.517-4.371-70a.133.133 0 01.114-.133.133.133 0 01.123.123c0 .474 2.93 48.361 4.371 69.991 1.328 19.913 8.392 85.59 8.458 86.291a.114.114 0 01-.1.133z"
            opacity={0.2}
          />
          <path
            data-name="Path 11481"
            d="M342.909 66.7c0 .578-.36 1.043-.74 1.043s-.654-.465-.616-1.043.36-1.043.74-1.043.654.46.616 1.043z"
            fill="#263238"
          />
          <path
            data-name="Path 11482"
            d="M336.403 66.7c0 .578-.37 1.043-.74 1.043s-.654-.465-.626-1.043.37-1.043.749-1.043.655.46.617 1.043z"
            fill="#263238"
          />
          <path
            data-name="Path 11483"
            d="M338.451 66.985a22.077 22.077 0 01-3.034 4.931 3.243 3.243 0 002.721.512z"
            fill="#df5753"
          />
          <path
            data-name="Path 11484"
            d="M338.622 74.845a.161.161 0 01-.161-.171.18.18 0 01.18-.171 4.855 4.855 0 003.793-1.783.171.171 0 01.237 0 .161.161 0 010 .237 5.177 5.177 0 01-4.049 1.888z"
            fill="#263238"
          />
          <path
            data-name="Path 11485"
            d="M344.066 64.946a.322.322 0 01-.294 0 2.665 2.665 0 00-2.4-.275.313.313 0 01-.436-.161.341.341 0 01.18-.446 3.328 3.328 0 013.063.284.332.332 0 01.085.465.313.313 0 01-.198.133z"
            fill="#263238"
          />
          <path
            data-name="Path 11486"
            d="M333.893 63.059a.369.369 0 01-.133-.076.332.332 0 010-.474 3.509 3.509 0 012.921-1.176.313.313 0 01.266.379.36.36 0 01-.4.284 2.845 2.845 0 00-2.3.948.36.36 0 01-.351.114z"
            fill="#263238"
          />
          <path
            data-name="Path 11487"
            d="M369.562 101.805l-9.86-2.617s-9.672 23.8-13.1 25.356c-4.646 2.115-16.414 9.435-21.421 12.963-.275 1.176-.057 4.324.569 5.177 8.534-1.546 24.873-7.833 28.286-11.028 7.79-7.292 15.526-29.851 15.526-29.851z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11488"
            d="M362.68 336.574a2.076 2.076 0 01-1.356-.36.948.948 0 01-.294-.891.588.588 0 01.322-.484c.8-.4 3.025 1.015 3.281 1.176a.152.152 0 01.066.171.171.171 0 01-.133.133 8.407 8.407 0 01-1.887.256zm-.948-1.47a.5.5 0 00-.218 0 .209.209 0 00-.114.2.655.655 0 00.19.616 3.4 3.4 0 002.522.123 6.41 6.41 0 00-2.409-.939z"
            fill="#407bff"
          />
          <path
            data-name="Path 11489"
            d="M364.516 336.323h-.076c-.711-.4-2.048-1.963-1.849-2.759a.569.569 0 01.559-.446.863.863 0 01.711.218c.787.673.834 2.74.834 2.845a.152.152 0 01-.085.152.162.162 0 01-.094-.01zm-1.271-2.892h-.066c-.218 0-.247.133-.256.171-.114.474.73 1.659 1.432 2.209a3.973 3.973 0 00-.711-2.238.616.616 0 00-.4-.142z"
            fill="#407bff"
          />
          <path
            data-name="Path 11490"
            d="M337.507 335.398a2.722 2.722 0 01-1.792 0 .949.949 0 01-.465-.73.578.578 0 01.2-.5c.759-.673 3.859.057 4.21.142a.152.152 0 01.114.142.161.161 0 01-.1.171 12.951 12.951 0 01-2.167.775zm-1.546-1.128a.776.776 0 00-.294.133.209.209 0 00-.076.209.569.569 0 00.3.474c.5.275 1.669.057 3.177-.569a9.331 9.331 0 00-3.11-.247z"
            fill="#407bff"
          />
          <path
            data-name="Path 11491"
            d="M339.638 334.631h-.076c-.948-.171-2.845-1.261-2.9-2.077 0-.19.085-.455.541-.607a1.176 1.176 0 01.948.057c1.024.5 1.565 2.323 1.593 2.4a.19.19 0 01-.047.171.17.17 0 01-.057.057zm-2.247-2.4h-.095c-.294.1-.294.228-.294.266 0 .484 1.375 1.384 2.333 1.688a3.594 3.594 0 00-1.328-1.9.873.873 0 00-.616-.057z"
            fill="#407bff"
          />
          <path
            data-name="Path 11492"
            d="M325.992 136.947l-9.89 4.552-1.147 2.788 3.651 2.465s6.827-.749 8.771-5.13z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11493"
            d="M326.409 142.846a13.5 13.5 0 00-1.84-5.367l1.565-1.166a15.257 15.257 0 012.2 6.211z"
            fill="#263238"
          />
          <path
            data-name="Path 11494"
            d="M328.097 138.294a1.9 1.9 0 11-2.314-.74 1.735 1.735 0 012.314.74z"
            fill="#263238"
          />
          <path
            data-name="Path 11495"
            d="M309.416 145.179l1.318 1.328 8.876-3.793-3.509-1.214z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11496"
            d="M347.527 318.491c.057 0 1.346 3.632 1.346 3.632l-13.124 5.509-2.067-3.84z"
            opacity={0.2}
          />
          <path
            data-name="Path 11497"
            d="M374.353 323.09c.057 0 .436 3.66.436 3.66h-14.376l-1.024-4.201z"
            opacity={0.2}
          />
          <path
            data-name="Path 11498"
            d="M372.134 99.084c2.608 8.4-7.586 19.913-7.586 19.913l-14.082-5.746a145.627 145.627 0 015.765-14.3c4.325-9.321 13.267-8.354 15.903.133z"
            fill="#cf1e22"
          />
        </g>
        <g transform="translate(179.77 14.812)">
          <path
            data-name="Rectangle 1801"
            fill="#407bff"
            d="M46.379 0h6.059v.977h-6.059z"
          />
          <path
            data-name="Rectangle 1802"
            fill="#407bff"
            d="M130.148 54.927l.733-16.274.976.043-.733 16.275z"
          />
          <path
            data-name="Path 11500"
            d="M128.991 4.381H17.097L6.685 237.387h111.894z"
            fill="#407bff"
          />
          <path
            data-name="Path 11501"
            d="M125.653 7.577H13.759L3.347 240.583h111.89z"
            fill="#fafafa"
            opacity={0.56}
          />
          <path
            data-name="Path 11502"
            d="M122.32 10.772H10.42L0 243.778h111.894z"
            fill="#407bff"
            opacity={0.07}
          />
          <path
            data-name="Path 11503"
            d="M109.581 112.397H14.073l-.8 17.837h95.508z"
            fill="#fff"
          />
          <path
            data-name="Path 11504"
            d="M66.596 99.396H14.651l-.351 7.975h51.945z"
            fill="#407bff"
          />
          <path
            data-name="Path 11505"
            d="M107.428 160.521H11.92l-.8 17.827h95.508z"
            fill="#fff"
          />
          <path
            data-name="Path 11506"
            d="M89.914 202.415H25.689l-.958 21.374h64.225z"
            fill="#407bff"
            opacity={0.47}
          />
          <path
            data-name="Path 11507"
            d="M85.618 227.098h-64.31a.152.152 0 010-.085l.95-21.374a.1.1 0 01.114-.1h64.225a.1.1 0 01.076 0v.085l-.929 21.374a.123.123 0 01-.126.1zm-64.112-.218h64l.948-21.156h-64z"
            fill="#fff"
          />
          <path
            data-name="Path 11508"
            d="M55.378 147.511h-42.88l-.351 7.975h42.871z"
            fill="#407bff"
          />
          <path
            data-name="Path 11509"
            d="M88.69 54.816a25.158 25.158 0 01-5.282 14.224 25.508 25.508 0 01-20.1 10.023 23.043 23.043 0 01-23.194-24.285 25.6 25.6 0 0125.363-24.292 23.033 23.033 0 0123.213 24.33z"
            fill="#fff"
          />
          <path
            data-name="Path 11510"
            d="M90.976 35.607a6.638 6.638 0 01-1.4 3.793 6.8 6.8 0 01-5.348 2.684 6.145 6.145 0 01-5.121-2.684 6.269 6.269 0 01-1.062-3.793 6.818 6.818 0 016.752-6.458 6.135 6.135 0 016.183 6.458z"
            fill="#407bff"
          />
          <path
            data-name="Path 11511"
            d="M24.361 121.315a3.025 3.025 0 01-2.987 2.845 2.7 2.7 0 01-2.731-2.845 3.015 3.015 0 012.987-2.845 2.721 2.721 0 012.731 2.845z"
            fill="#263238"
          />
          <path
            data-name="Path 11512"
            d="M37.143 121.315a3.015 3.015 0 01-2.987 2.845 2.7 2.7 0 01-2.722-2.845 3.015 3.015 0 012.978-2.845 2.7 2.7 0 012.731 2.845z"
            fill="#263238"
          />
          <path
            data-name="Path 11513"
            d="M49.935 121.315a3.015 3.015 0 01-2.987 2.845 2.712 2.712 0 01-2.731-2.845 3.025 3.025 0 012.987-2.845 2.712 2.712 0 012.731 2.845z"
            fill="#263238"
          />
          <path
            data-name="Path 11514"
            d="M22.208 169.435a3.025 3.025 0 01-2.987 2.845 2.712 2.712 0 01-2.731-2.845 3.016 3.016 0 012.987-2.845 2.712 2.712 0 012.731 2.845z"
            fill="#263238"
          />
          <path
            data-name="Path 11515"
            d="M34.99 169.435a3.006 3.006 0 01-2.978 2.845 2.7 2.7 0 01-2.731-2.845 3.016 3.016 0 012.987-2.845 2.7 2.7 0 012.721 2.845z"
            fill="#263238"
          />
          <path
            data-name="Path 11516"
            d="M47.811 169.435a3.016 3.016 0 01-2.987 2.845 2.712 2.712 0 01-2.731-2.845 3.025 3.025 0 012.987-2.845 2.7 2.7 0 012.731 2.845z"
            fill="#263238"
          />
          <path
            data-name="Path 11517"
            d="M60.575 169.435a3.025 3.025 0 01-2.987 2.845 2.712 2.712 0 01-2.731-2.845 3.025 3.025 0 012.987-2.845 2.712 2.712 0 012.731 2.845z"
            fill="#263238"
          />
          <path
            data-name="Path 11518"
            d="M73.414 169.435a3.025 3.025 0 01-2.987 2.845 2.7 2.7 0 01-2.731-2.845 3.015 3.015 0 012.987-2.845 2.712 2.712 0 012.731 2.845z"
            fill="#263238"
          />
          <ellipse
            data-name="Ellipse 595"
            cx={10.052}
            cy={9.606}
            rx={10.052}
            ry={9.606}
            transform="rotate(-44.36 82.868 -38.93)"
            fill="#407bff"
          />
          <path
            data-name="Path 11519"
            d="M83.413 69.09a25.508 25.508 0 01-20.1 9.976 23.033 23.033 0 01-19.2-9.976c4.609-4.59 11.9-7.586 19.98-7.586s15.115 2.996 19.32 7.586z"
            fill="#407bff"
          />
          <ellipse
            data-name="Ellipse 596"
            cx={10.052}
            cy={9.606}
            rx={10.052}
            ry={9.606}
            transform="rotate(-44.36 82.868 -38.93)"
            fill="#fff"
            opacity={0.1}
          />
          <path
            data-name="Path 11520"
            d="M83.413 69.09a25.508 25.508 0 01-20.1 9.976 23.033 23.033 0 01-19.2-9.976c4.609-4.59 11.9-7.586 19.98-7.586s15.115 2.996 19.32 7.586z"
            opacity={0.1}
          />
        </g>
        <g data-name="Character 1" transform="translate(103.132 97.567)">
          <path
            data-name="Path 11521"
            d="M20.53 51.774c-.9 1.972-1.849 4.134-2.674 6.249s-1.669 4.267-2.4 6.439a81.551 81.551 0 00-3.394 13.086l-.209 1.394a2.038 2.038 0 00.066.711 7.255 7.255 0 001.043 2.19 27.5 27.5 0 004.21 4.741 63.864 63.864 0 005.234 4.371c1.821 1.4 3.736 2.769 5.623 4.059l-1.773 3.319a66.643 66.643 0 01-12.754-7.292 30.714 30.714 0 01-5.69-5.386 13.636 13.636 0 01-2.266-4.049 9.246 9.246 0 01-.455-2.8v-1.195l.095-.948a74.017 74.017 0 013.1-14.546c.74-2.342 1.527-4.656 2.428-6.932s1.83-4.485 2.978-6.78z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11522"
            d="M26.694 94.436l6.7-3.4-1.735 7.368s-4.6 1.29-6.733-.948z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11523"
            d="M39.533 92.241l-1.783 6.088-6.088.066 1.735-7.358z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11524"
            d="M48.996 16.271a19.163 19.163 0 001.508 3.793 1.546 1.546 0 01-1.508.484z"
            fill="#df5753"
          />
          <ellipse
            data-name="Ellipse 597"
            cx={0.711}
            cy={1.09}
            rx={0.711}
            ry={1.09}
            transform="translate(48.086 14.147)"
            fill="#263238"
          />
          <path
            data-name="Path 11525"
            d="M48.589 14.185l1.441-.417s-.701 1.128-1.441.417z"
            fill="#263238"
          />
          <path
            data-name="Path 11526"
            d="M30.477 23.222c.863 4.419 1.726 12.508-1.366 15.447 0 0 1.214 4.485 9.416 4.485 9.018 0 4.305-4.476 4.305-4.476-4.921-1.176-4.8-4.836-3.935-8.259z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11527"
            d="M28.078 13.177c.455 7.368.493 10.5 4.21 14.281 5.6 5.69 14.556 3.518 16.31-3.793 1.584-6.638.578-17.562-6.638-20.5a10.08 10.08 0 00-13.882 10.012z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11528"
            d="M28.808 4.844c-3.7 1.347-8.629.341-6.695 11.749 2.048 12.071-1.1 16.044-1.1 16.044s14.025 3 28.343-.171c0 0-4.371-7.652-3.148-13.228 1.565-7.112.332-9.739.332-9.739S34.004 2.948 28.808 4.844z"
            fill="#263238"
          />
          <path
            data-name="Path 11529"
            d="M44.454 17.02a7.406 7.406 0 001.157 3.954c1.005 1.536 2.19.948 2.484-.683.266-1.441.066-3.973-1.214-4.95s-2.408.01-2.427 1.679z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11530"
            d="M25.593 6.134c-1.062-2.987 4-7.586 14.717-5.69s11.18 10.81 11.18 10.81l-2.162-2.57.095 2.712-11.009 2.113z"
            fill="#263238"
          />
          <path
            data-name="Path 11531"
            d="M26.504 39.172a1.669 1.669 0 011.375-1.9c3.338-.55 10.924-1.669 14.736-1.138 2.845.389 3.584 2.048 3.708 3.4a1.669 1.669 0 01-1.754 1.8l-16.481-.74a1.688 1.688 0 01-1.584-1.422z"
            fill="#407bff"
          />
          <path
            data-name="Path 11532"
            d="M26.504 39.172a1.669 1.669 0 011.375-1.9c3.338-.55 10.924-1.669 14.736-1.138 2.845.389 3.584 2.048 3.708 3.4a1.669 1.669 0 01-1.754 1.8l-16.481-.74a1.688 1.688 0 01-1.584-1.422z"
            opacity={0.6}
          />
          <path
            data-name="Path 11533"
            d="M36.034 204.841l6.116 4.239 10.232-13.863-6.116-4.248z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11534"
            d="M21.772 204.557l6.458 3.689 9.056-14.67-6.458-3.689z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11535"
            d="M52.373 195.217l-5.272 7.15-6.116-4.248 5.272-7.14z"
            fill="#cf6f64"
          />
          <path
            data-name="Path 11536"
            d="M30.818 189.897l6.467 3.679-4.665 7.558-6.467-3.679z"
            fill="#cf6f64"
          />
          <path
            data-name="Path 11537"
            d="M41.195 85.446s23.877 30.088 19.392 58.868c-3.613 23.242-24.569 54.714-24.569 54.714l-9.852-4.893a321.7 321.7 0 0017.729-43.089 31.852 31.852 0 00-3.793-27.594c-12.1-17.666-31.482-7.159-18.444-38.006z"
            fill="#407bff"
          />
          <path
            data-name="Path 11538"
            d="M41.195 85.446s23.877 30.088 19.392 58.868c-3.613 23.242-24.569 54.714-24.569 54.714l-9.852-4.893a321.7 321.7 0 0017.729-43.089 31.852 31.852 0 00-3.793-27.594c-12.1-17.666-31.482-7.159-18.444-38.006z"
            opacity={0.6}
          />
          <path
            data-name="Path 11539"
            d="M52.904 104.82l-3.471-3.452c0 .275 6.723 41.771 8.61 53.434a70.845 70.845 0 002.551-10.431c2.219-14.11-2.418-28.523-7.69-39.551z"
            opacity={0.4}
          />
          <path
            data-name="Path 11540"
            d="M51.851 85.446s28.751 37.816 29.567 60.489c.673 18.965-31.292 55.71-31.292 55.71l-9.293-6.012s18.709-26.1 23.422-47.413c-1.821-21.051-40.321-62.774-40.321-62.774z"
            fill="#407bff"
          />
          <path
            data-name="Path 11541"
            d="M51.851 85.446s28.751 37.816 29.567 60.489c.673 18.965-31.292 55.71-31.292 55.71l-9.293-6.012s18.709-26.1 23.422-47.413c-1.821-21.051-40.321-62.774-40.321-62.774z"
            opacity={0.6}
          />
          <path
            data-name="Path 11542"
            d="M16.28 40.366c-3.072.721-6.021 11.9-6.021 11.9l12.014 8.013s4-8.828 2.6-12.7c-1.451-4.027-4.732-8.133-8.593-7.213z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 11543"
            d="M18.633 47.516l-.834 9.739 4.466 3a40.226 40.226 0 002.721-8.667z"
            opacity={0.2}
          />
          <path
            data-name="Path 11544"
            d="M55.407 40.575s3.546 1.252-3.556 44.909H21.64c.512-12.327.522-19.913-5.358-45.118a90.22 90.22 0 0112.83-1.7 97.277 97.277 0 0113.721 0c5.898.546 12.574 1.909 12.574 1.909z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 11545"
            d="M58.479 47.516c.683 1.9 1.4 3.945 2.162 5.908s1.479 3.983 2.247 5.965l2.323 5.955.588 1.489.3.749.142.37v.057a2.02 2.02 0 00-.664-.6 2.589 2.589 0 00-1.233-.36 2.5 2.5 0 00-1.053.19c-.436.209-.436.294-.427.284a1.593 1.593 0 00.209-.218 13.276 13.276 0 001.356-2.209c.446-.872.872-1.8 1.3-2.74.834-1.9 1.6-3.859 2.371-5.841s1.5-3.992 2.209-6l2.162-6.059 3.651.948c-.721 4.324-1.65 8.534-2.769 12.82a83.84 83.84 0 01-1.9 6.382 47.922 47.922 0 01-1.214 3.215 20.132 20.132 0 01-1.745 3.4 8.838 8.838 0 01-.835 1.024 5.272 5.272 0 01-1.726 1.223 4.248 4.248 0 01-1.84.341 4.182 4.182 0 01-2-.607 5.017 5.017 0 01-1.726-1.783 10.217 10.217 0 01-.351-.673l-.18-.37-.36-.73-.721-1.479c-.948-1.972-1.9-3.954-2.721-5.955s-1.7-4.04-2.513-6.069-1.546-4.077-2.238-6.277z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11546"
            d="M55.406 40.575c3.632.872 7.719 11.6 7.719 11.6l-10.8 9.2s-6.989-11.7-5.576-15.561c1.47-3.988 3.916-6.368 8.657-5.239z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 11547"
            d="M74.188 41.106l3.8-3.167 2.636 4.1-1.944 3.433s-3.091 2.845-5.822 1.394a4.9 4.9 0 011.33-5.76z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11548"
            d="M84.831 37.948l-.284 1.024-6 1.015-.588-2.048z"
            fill="#e58a7b"
          />
          <path
            data-name="Path 11549"
            d="M50.864 202.177l-10.829-7.008 1.944-3.366 12.166 7.482z"
            fill="#407bff"
          />
          <path
            data-name="Path 11550"
            d="M32.468 207.768a6.391 6.391 0 01-2.674-.948.161.161 0 01-.095-.171.2.2 0 01.123-.152c.294-.085 2.845-.872 3.584-.266a.588.588 0 01.209.569 1.015 1.015 0 01-.541.825 1.365 1.365 0 01-.606.143zm-2.134-1.034c1.185.6 2.134.825 2.589.6a.664.664 0 00.341-.559.228.228 0 00-.085-.247c-.4-.351-1.821-.1-2.864.18z"
            fill="#263238"
          />
          <path
            data-name="Path 11551"
            d="M29.861 206.823a.19.19 0 01-.133-.057.18.18 0 010-.171c0-.085.616-2.143 1.584-2.617a.948.948 0 01.787 0 .626.626 0 01.436.635c-.066.853-1.8 2.029-2.6 2.219zm1.84-2.589a.522.522 0 00-.265.066c-.588.275-1.072 1.394-1.309 2.067.834-.351 1.982-1.28 2.02-1.8 0-.085 0-.2-.218-.284a.7.7 0 00-.228-.028z"
            fill="#263238"
          />
          <path
            data-name="Path 11552"
            d="M46 211.84c-1.072 0-2.56-1.366-3.376-2.209a.171.171 0 010-.2.208.208 0 01.18-.1c.379.057 3.67.493 4.134 1.432a.54.54 0 010 .55.948.948 0 01-.749.531zm-2.75-2.086c1.195 1.166 2.247 1.811 2.845 1.735a.645.645 0 00.493-.351.218.218 0 000-.228c-.247-.5-2-.939-3.338-1.157z"
            fill="#263238"
          />
          <path
            data-name="Path 11553"
            d="M43.354 209.725a3.1 3.1 0 01-.635-.047.207.207 0 01-.133-.284c.057-.066 1.337-1.612 2.551-1.716a1.28 1.28 0 01.948.3c.37.322.351.607.256.787-.237.638-1.878.96-2.987.96zm-.247-.351c1.062.057 2.759-.294 2.978-.759 0 0 .076-.152-.171-.37a.948.948 0 00-.721-.218 4.03 4.03 0 00-2.086 1.35z"
            fill="#263238"
          />
          <path
            data-name="Path 11554"
            d="M30.117 205.875l-8.041-2.276a.588.588 0 00-.711.322l-2.712 6.107a1.195 1.195 0 00.787 1.6c2.845.74 4.21.948 7.747 1.953 2.181.616 5.291 1.745 8.3 2.589s4.011-2.077 2.845-2.693c-5.272-2.8-5.69-4.741-7.131-6.827a1.9 1.9 0 00-1.084-.775z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 11555"
            d="M42.842 208.521l-6.865-4.741a.6.6 0 00-.778.085l-4.552 4.884a1.195 1.195 0 00.228 1.773c2.418 1.612 3.67 2.276 6.695 4.371 1.9 1.29 5.566 4.153 8.127 5.936s4.466-.664 3.556-1.631c-4.077-4.362-4.969-7.093-5.642-9.568a1.944 1.944 0 00-.769-1.109z"
            fill="#cf1e22"
          />
          <path
            data-name="Path 11556"
            d="M37.276 199.693l-12.375-6.154 1.28-3.347 13.219 6.477z"
            fill="#407bff"
          />
          <path
            data-name="Path 11557"
            d="M21.184 83.711l-1.042 2.684c-.1.209.142.417.493.417h31.367c.275 0 .5-.133.522-.3l.266-2.7c0-.19-.218-.341-.512-.341h-30.6a.55.55 0 00-.494.24z"
            fill="#407bff"
          />
          <path
            data-name="Path 11558"
            d="M21.184 83.711l-1.042 2.684c-.1.209.142.417.493.417h31.367c.275 0 .5-.133.522-.3l.266-2.7c0-.19-.218-.341-.512-.341h-30.6a.55.55 0 00-.494.24z"
            fill="#fff"
            opacity={0.4}
          />
          <path
            data-name="Path 11559"
            d="M26.125 87.125H25.3c-.161 0-.284-.076-.275-.18l.389-3.518c0-.1.152-.19.313-.19h.825c.161 0 .285.085.275.19l-.389 3.518c-.01.104-.152.18-.313.18z"
            fill="#407bff"
          />
          <path
            data-name="Path 11560"
            d="M45.468 87.125h-.816c-.161 0-.284-.076-.275-.18l.379-3.518c0-.1.161-.19.322-.19h.815c.161 0 .294.085.275.19l-.379 3.518a.326.326 0 01-.321.18z"
            fill="#407bff"
          />
          <ellipse
            data-name="Ellipse 598"
            cx={25.404}
            cy={1.84}
            rx={25.404}
            ry={1.84}
            transform="translate(0 244.042)"
            fill="#f5f5f5"
          />
          <path
            data-name="Path 11561"
            d="M40.879 243.284c-4.495-1.309-9.483-2.987-12.5-4.741l-.266-.123v-20.36h9.094a2.712 2.712 0 000-5.415h-9.046v-92.767h-5.462v92.768h-9.037a2.712 2.712 0 100 5.415h9.037v20.321l-.256.123c-3.063 1.792-8.013 3.471-12.507 4.741a1.328 1.328 0 00.37 2.6h30.2a1.328 1.328 0 00.37-2.56z"
            fill="#e0e0e0"
          />
          <rect
            data-name="Rectangle 1803"
            width={43.544}
            height={19.847}
            rx={5.18}
            transform="translate(3.641 110.443)"
            fill="#ffb921"
          />
          <path
            data-name="Path 11562"
            d="M8.24 130.29v1.726c0 1.422 1.546 2.589 3.442 2.589h27.5c1.9 0 3.442-1.166 3.442-2.589v-1.726z"
            fill="#878787"
          />
        </g>
      </g>
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
